import axios from 'axios';

// Client for the eIFU critical-notice API. Mirrors lib/visibility.js.
// The public portal reads active notices and shows the first undismissed one in
// a modal; the admin console reads ALL notices (incl. expired) and
// creates/deletes them through the Access-gated endpoint under /admin.
//
//   READ (public)  — GET    /api/notice            (active only)
//   READ (admin)   — GET    /admin/api/notice       (all, incl. expired)
//   CREATE         — POST   /admin/api/notice       (Cloudflare Access)
//   DELETE         — DELETE /admin/api/notice?id=…  (Cloudflare Access)
const READ_URL = '/api/notice';
const WRITE_URL = '/admin/api/notice';

// Fetch active notices (newest first). Returns [] on failure so the portal
// degrades to "no notice shown".
export const getNotices = async () => {
  try {
    const res = await axios.get(READ_URL);
    return Array.isArray(res?.data?.notices) ? res.data.notices : [];
  } catch (error) {
    console.warn('ERROR[getNotices]', error?.toString());
    return [];
  }
};

// Admin-only: fetch every notice including expired ones (each carries expiresAt).
// Sends credentials so the Cloudflare Access cookie rides along.
export const getAllNotices = async () => {
  try {
    const res = await axios.get(WRITE_URL, { withCredentials: true });
    return Array.isArray(res?.data?.notices) ? res.data.notices : [];
  } catch (error) {
    console.warn('ERROR[getAllNotices]', error?.toString());
    return [];
  }
};

// Create one notice. Sends credentials so the Cloudflare Access cookie rides
// along; the Function verifies it before writing.
// notice: { content: { en: {title, body}, ... }, expiresInDays }
//   expiresInDays: positive integer, or null/omitted for "no expiry".
export const addNotice = async (notice) => {
  const res = await axios.post(WRITE_URL, notice, { withCredentials: true });
  return res?.data;
};

export const deleteNotice = async (id) => {
  const res = await axios.delete(WRITE_URL, {
    params: { id },
    withCredentials: true,
  });
  return res?.data;
};
